import React, { useMemo } from 'react';
import Icon from '@mdi/react';
import { mdiSchool, mdiCalendarCheck, mdiTicketOutline, mdiCreditCardPlus } from '@mdi/js';
import { formatCurrencyFromMinor } from '../../utils/currency';
import './RevenueBreakdown.css';

const STREAMS = [
  { type: 'class_payment', label: 'Classes', icon: mdiSchool, colorClass: 'stream-class' },
  { type: 'class_adjustment', label: 'Adjustments', icon: mdiCreditCardPlus, colorClass: 'stream-class' },
  { type: 'booking_payment', label: 'Private Lessons', icon: mdiCalendarCheck, colorClass: 'stream-booking' },
  { type: 'ticket_purchase', label: 'Tickets', icon: mdiTicketOutline, colorClass: 'stream-ticket' },
];

function RevenueBreakdown({ transactions, currency }) {
  // Currency comes from the earnings summary (same source as the top row), with
  // the transactions' own stamped currency as a fallback. Never hardcode AUD —
  // a non-AUD org (e.g. NZD) would otherwise show A$ here while the rest shows NZ$.
  const displayCurrency = currency || transactions?.[0]?.amounts?.currency;
  const formatCurrency = (amount) => formatCurrencyFromMinor(amount, displayCurrency);

  const thisMonth = useMemo(() => {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

    const monthly = (transactions || []).filter(txn =>
      txn.status === 'succeeded' && new Date(txn.createdAt) >= startOfMonth
    );

    const byType = {};
    monthly.forEach(txn => {
      const type = txn.type || 'other';
      if (!byType[type]) byType[type] = { amount: 0, count: 0 };
      byType[type].amount += txn.amounts?.instructorReceives || 0;
      byType[type].count += 1;
    });

    return byType;
  }, [transactions]);

  return (
    <div className="revenue-breakdown">
      <h3 className="revenue-breakdown-title">This Month</h3>
      <div className="revenue-columns">
        {STREAMS.map(({ type, label, icon, colorClass }) => {
          const data = thisMonth[type];
          return (
            <div key={type} className="revenue-column">
              <div className={`revenue-column-icon ${colorClass}`}>
                <Icon path={icon} size={0.65} />
              </div>
              <span className="revenue-column-label">{label}</span>
              <span className="revenue-column-amount">{formatCurrency(data?.amount)}</span>
              <span className="revenue-column-count">
                {data?.count || 0} transaction{(data?.count || 0) !== 1 ? 's' : ''}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RevenueBreakdown;
